import { atomWithReset } from 'jotai/utils'

import { type DocumentReport } from './hooks/useArchivedDocumentReportsInfiniteQuery'

type DialogInfo = {
  dialogType: 'delete'
  documentReport: DocumentReport
}

export const dialogInfoAtom = atomWithReset<DialogInfo | undefined>(undefined)
